<div *ngIf="loggedInUser$ | async as loggedInUser">
  <article
    *ngIf="invitee && loggedInUser.role !== roleEnum.POOL"
    class="invitee-list-item-wrapper"
    data-cy="job-request-invitee"
    (click)="toggleDetails($event)">
    <div class="list-item-header">
      <div class="header-left">
        <div>
          <div
            class="employee-name"
            data-cy="job-request-invitee-name">
            <div
              class="employee-name__name"
              [class.is-canceled]="isCanceled">
              {{
                loggedInCustomer?.prioritizeEmployeeLastName
                  ? invitee.personalData?.lastName
                  : invitee.personalData?.firstName
              }}
              {{
                loggedInCustomer?.prioritizeEmployeeLastName
                  ? invitee.personalData?.firstName
                  : invitee.personalData?.lastName
              }}
            </div>
            <div
              class="employee-name__canceled-text"
              *ngIf="isCanceled">
              ({{ "canceled" | i18n | titlecase }})
            </div>
          </div>
          <div
            class="employee-customer"
            *ngIf="invitee?.customer?.id !== loggedInUser.customerId"
            [attr.data-cy]="'origin-customer-id-' + invitee?.customer?.id">
            via
            {{ invitee?.customer?.displayName }}
          </div>
        </div>
        <div
          *ngIf="
            user?.customerInformation?.[loggedInUser?.customerId || ''] &&
            user?.customerInformation?.[loggedInUser?.customerId || '']?.poolerType"
          class="custom-chip small-pill poolertype-pill">
          {{user?.customerInformation?.[loggedInUser?.customerId || '']?.poolerType?.displayName | uppercase}}
        </div>
      </div>
      <div
        *ngIf="!uncollapsable"
        class="header-right">
        <div
          *ngIf="invitee.additionalInfo"
          class="availability-note"
          data-cy="user-list-item__availability-note"
          [matTooltip]="invitee.additionalInfo"
          matTooltipPosition="above">
          <mat-icon
            class="size-20 text-icon-grey"
            svgIcon="note"></mat-icon>
          <span class="d-none d-md-block">
            {{ "hasNote" | i18n }}
          </span>
          <span class="d-block d-md-none">
            {{ "note" | i18n }}
          </span>
        </div>
        <mat-icon
          class="collapse-toggle"
          [class.rotate]="rotateChevron"
          svgIcon="chevron-down"></mat-icon>
      </div>
    </div>
    <div
      *ngIf="!uncollapsable"
      class="collapse-wrapper"
      [class.collapsed]="!animationShowDetails">
      <div
        *ngIf="showDetails"
        class="collapse-child"
        [attr.data-cy]="'user-list-item-details-' + user?._id">
        <user-list-item-details
          class="list-item-details"
          [noPadding]="true"
          [showContactInfo]="!loggedInCustomer?.hideContactInfoInJobRequest"
          [user]="user"
          [invitee]="invitee"></user-list-item-details>
      </div>
    </div>
  </article>
</div>
